"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _space = _interopRequireDefault(require("./space"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  listItems: {
    "default": {
      paddingLeft: _space["default"][4],
      paddingRight: _space["default"][4],
      paddingTop: _space["default"][3],
      paddingBottom: _space["default"][3]
    },
    dense: {
      paddingLeft: _space["default"][2],
      paddingRight: _space["default"][2],
      paddingTop: _space["default"][1],
      paddingBottom: _space["default"][1]
    }
  }
};
exports["default"] = _default;